import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import {
    IFormUUID,
    WebPageURL,
    isoFormUUID,
    isoReviewsBrandID,
    isoWebPageURL,
} from "../../../models/nominals";
import { useSSRStorePrefill } from "../../../store/reducers";
import { SingleProductWriteReviewForm } from "../SingleProductWriteReviewForm";
import { prefillSSRWriteReviewData } from "../ssr";

type IProps = Immutable<
    templates.WriteReviewTemplate & {
        // Site-specific overrides (not in Django template context)
        brand?: string;
    }
>;

export const WriteReviewSSR = (props: IProps): React.JSX.Element => {
    const formUUID: IFormUUID = isoFormUUID.wrap(React.useId());

    useSSRStorePrefill(
        {
            products_data: props.products_data,
            review_template_data: props.review_template_data,
            brand_id: props.brand_id,
            formUUID,
        },
        prefillSSRWriteReviewData,
    );

    const brandID = isoReviewsBrandID.wrap(props.brand_id);
    const returnURL: WebPageURL | undefined = props.return_url
        ? isoWebPageURL.wrap(props.return_url)
        : undefined;

    return (
        <SingleProductWriteReviewForm
            formUUID={formUUID}
            brandID={brandID}
            brand={props.brand}
            returnURL={returnURL}
        />
    );
};
